class CustomProduct {
  constructor(section) {
    this.section = section;

    this.variantData = JSON.parse(
      section.querySelector("[data-variants]")?.textContent || "[]",
    );

    this.currentOptions = [];

    this.variantInput = section.querySelector('[name="id"]');

    this.init();
  }

  init() {
    this.loadSelectedVariant();

    this.bindVariantEvents();

    this.bindQuantity();

    this.bindAccordion();

    this.bindAddToCart();

    this.bindGallery();

    this.bindZoom();

    this.bindBrowserNavigation();
  }

  bindVariantEvents() {
    this.section.querySelectorAll("[data-option-value]").forEach((button) => {
      button.addEventListener("click", () => {
        let position = Number(button.dataset.optionPosition);

        let value = button.dataset.optionValue;

        this.currentOptions[position - 1] = value;

        this.updateActiveButtons(position, value);

        this.findVariant(true);
      });
    });
  }

  updateActiveButtons(position, value) {
    this.section
      .querySelectorAll(`[data-option-position="${position}"]`)
      .forEach((btn) => btn.classList.remove("is-active"));

    let active = this.section.querySelector(
      `[data-option-position="${position}"][data-option-value="${CSS.escape(value)}"]`,
    );

    active?.classList.add("is-active");
  }

  findVariant(updateURL = false) {
    let variant = this.variantData.find((item) => {
      return item.options.every(
        (option, index) => option === this.currentOptions[index],
      );
    });

    if (!variant) return;

    this.updateVariant(variant, updateURL);
  }

  updateVariant(variant, updateURL = false) {
    if (this.variantInput) {
      this.variantInput.value = variant.id;
    }

    /* IMAGE */

    if (variant.featured_media) {
      let mediaButton = this.section.querySelector(
        `[data-media-id="${variant.featured_media}"]`,
      );

      mediaButton?.click();
    }

    /* PRICE */

    let price = this.section.querySelector("[data-price]");

    if (price) {
      price.innerHTML = this.formatMoney(variant.price);
    }

    /* COMPARE PRICE */

    let compare = this.section.querySelector("[data-compare-price]");

    let sale = this.section.querySelector("[data-sale-badge]");

    if (variant.compare_price && variant.compare_price > variant.price) {
      compare.innerHTML = this.formatMoney(variant.compare_price);

      let discount = Math.round(
        ((variant.compare_price - variant.price) / variant.compare_price) * 100,
      );

      sale.innerHTML = `Save ${discount}%`;
    } else {
      if (compare) compare.innerHTML = "";

      if (sale) sale.innerHTML = "";
    }

    /* SKU */

    let sku = this.section.querySelector("[data-sku]");

    if (sku) {
      sku.innerHTML = variant.sku ? `SKU: ${variant.sku}` : "";
    }

    /* INVENTORY */

    let inventory = this.section.querySelector("[data-inventory]");

    if (inventory) {
      if (!variant.available) {
        inventory.innerHTML = "Sold Out";
      } else if (variant.inventory && variant.inventory <= 10) {
        inventory.innerHTML = `Only ${variant.inventory} left in stock`;
      } else {
        inventory.innerHTML = "In Stock";
      }
    }

    /* URL */

    if (updateURL) {
      let url = new URL(window.location.href);

      url.searchParams.set("variant", variant.id);

      window.history.pushState({}, "", url);
    }
  }

  loadSelectedVariant() {
    let params = new URLSearchParams(window.location.search);

    var id = params.get("variant");

    if (!id){
      var form = this.section.querySelector('form[action*="/cart/add"]');
      if(form){
        var IDinput = form.querySelector('[name="id"]');
        if(IDinput){
          id = IDinput.value;
        }else{
          return;
        }
      }else{
        return;
      }

    };

    let variant = this.variantData.find((item) => item.id == id);

    if (!variant) return;

    variant.options.forEach((option, index) => {
      this.currentOptions[index] = option;

      let button = this.section.querySelector(
        `[data-option-position="${index + 1}"][data-option-value="${CSS.escape(option)}"]`,
      );

      button?.classList.add("is-active");
    });

    this.updateVariant(variant, false);
  }

  bindBrowserNavigation() {
    window.addEventListener("popstate", () => {
      this.loadSelectedVariant();
    });
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
      style: "currency",
      currency: Shopify.currency?.active || "USD",
    }).format(cents / 100);
  }

  bindQuantity() {
    let input = this.section.querySelector(".quantity-input");

    let plus = this.section.querySelector("[data-quantity-plus]");

    let minus = this.section.querySelector("[data-quantity-minus]");

    if (!input) return;

    plus?.addEventListener("click", () => {
      input.value = Number(input.value) + 1;
    });

    minus?.addEventListener("click", () => {
      if (Number(input.value) > 1) {
        input.value = Number(input.value) - 1;
      }
    });
  }

  bindGallery() {
    let thumbs = this.section.querySelectorAll(".product-gallery__thumb");

    let main = this.section.querySelector("[data-main-media]");

    if (!main) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        thumbs.forEach((t) => t.classList.remove("is-active"));

        thumb.classList.add("is-active");

        let src = thumb.dataset.mediaSrc;

        if (!src) return;

        main.innerHTML = `
<img
class="product-gallery__image"
src="${src}"
loading="eager"
>
`;
      });
    });
  }

  bindZoom() {
    let button = this.section.querySelector("[data-zoom-button]");

    if (!button) return;

    button.addEventListener("click", () => {
      let img = this.section.querySelector(".product-gallery__image");

      if (!img) return;

      let modal = document.createElement("div");

      modal.className = "product-zoom-modal";

      modal.innerHTML = `
<img src="${img.src}">
`;

      document.body.appendChild(modal);

      modal.onclick = () => {
        modal.remove();
      };
    });
  }

  bindAccordion() {
    this.section.querySelectorAll(".accordion-trigger").forEach((trigger) => {
      trigger.addEventListener("click", () => {
        let content = trigger.nextElementSibling;

        let open = content.classList.toggle("is-open");

        trigger.setAttribute("aria-expanded", open);
      });
    });
  }

  bindAddToCart(){

  let form=
  this.section.querySelector(
    'form[action*="/cart/add"]'
  );

  if(!form)return;

  form.addEventListener(
    "submit",
    async(e)=>{

      e.preventDefault();

      let button=
      form.querySelector(
        "[data-add-to-cart]"
      );

      let buttonText=
      button?.querySelector(
        "[data-button-text]"
      );

      let loader=
      button?.querySelector(
        ".button-loader"
      );

      if(button)
        button.disabled=true;

      if(buttonText)
        buttonText.hidden=true;

      if(loader)
        loader.hidden=false;

      try{

        let response=
        await fetch(
          "/cart/add.js",
          {
            method:"POST",
            body:new FormData(form),
            headers:{
              Accept:"application/json"
            }
          }
        );

        let data=
        await response.json();

        if(response.ok){

          await this.updateCartCount();

          document.dispatchEvent(
            new CustomEvent(
              "cart:updated",
              {
                detail:data
              }
            )
          );

        } else {

          console.error(
            "Cart Add Error",
            data
          );

        }

      }
      catch(error){

        console.error(
          "Cart Error",
          error
        );

      }

      if(button)
        button.disabled=false;

      if(buttonText)
        buttonText.hidden=false;

      if(loader)
        loader.hidden=true;

    }

  );

}


updateCartCount(){

  return fetch(
    "/cart.js",
    {
      headers:{
        Accept:"application/json"
      },
      cache:"no-store"
    }
  )
  .then(res=>res.json())
  .then(cart=>{

    document
    .querySelectorAll(
      ".cart-count-bubble,.cart-count,[data-cart-count]"
    )
    .forEach(el=>{

      el.textContent=
      cart.item_count;

    });

  })
  .catch(error=>{

    console.error(
      "Cart Count Error",
      error
    );

  });

}

  updateCartCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        document
          .querySelectorAll(".cart-count-bubble,.cart-count,[data-cart-count]")
          .forEach((el) => {
            el.textContent = cart.item_count;
          });
      });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".custom-product-section").forEach((section) => {
    new CustomProduct(section);
  });
});
